<script setup>
import { useLoadingCheck } from '@/app/composables/';
const { loadingPrevent, loadingTabindex } = useLoadingCheck();
</script>

<template>
  <button
    @keydown="loadingPrevent"
    :tabindex="loadingTabindex"
    class="c-close-button"
    type="button"
  >
    <slot />
    <svg aria-hidden="true" focusable="false">
      <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#close"></use>
    </svg>
  </button>
</template>

<style lang="scss">
@import '@/ui/styles/functions/functions';
@import '@/ui/styles/mixins/buttons';
@import '@/ui/styles/mixins/focus';
@import '@/ui/styles/mixins/transitions';
@import '@/ui/styles/settings/colors';
@import '@/ui/styles/settings/units';

.c-close-button {
  @include removeDefaultButtonStyling();
  @include iconButton();
  @include defaultTransition(color);
  display: grid;
  place-content: center;
  height: rem(44px);
  width: rem(44px);
  color: $ssen-a11y-grey;
  cursor: pointer;
  transform: translate(#{rem(12px)}, #{rem(-12px)});

  &:hover {
    color: $color-brand-one;
  }
}
</style>
